import { fetchAdminUserResumes } from '../../../repository/AdminRepository';
import { useEffect, useState } from 'react';
import { AdminResumeType } from '../../../types/AdminTypes';
import Viewer from '../../ivy/Resume/Viewer/index.';
import S from './ResumeModal.module.scss';
import styled from 'styled-components';
import iconClose from '../../common/assets/icon_close.svg';

interface ResumeModalProps {
  id: number;
  closeModal: Function;
}

const ResumeModal = (props: ResumeModalProps) => {
  const { id, closeModal } = props;
  const ADMIN_TOKEN = process.env.REACT_APP_IVY_ADMIN_TOKEN || '';
  const [userResume, setUserResume] = useState<AdminResumeType>({} as AdminResumeType);

  const getResume = (token: string, id: number) => {
    fetchAdminUserResumes(token, id).then((res) => {
      if (res.userId > 0) {
        setUserResume(res);
      }
    });
  };

  useEffect(() => {
    getResume(ADMIN_TOKEN, id);
  }, []);

  if (userResume === undefined) {
    return null;
  }

  return (
    <DimModalContainer>
      <BackgroundDim></BackgroundDim>
      <ModalDiv>
        <IconWrap>
          <CloseImg src={iconClose} alt="닫기" onClick={() => closeModal()} />
        </IconWrap>
        <ViewerContainer>
          <Viewer
            isAdmin={true}
            resume={userResume.resume}
            isPreview={true}
            changeToEditMode={() => {}}
          />
        </ViewerContainer>
      </ModalDiv>
    </DimModalContainer>
  );
};

const DimModalContainer = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
`;

const BackgroundDim = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0.7;
  background: var(--neutral-gray-900);
`;

const ModalDiv = styled.div`
  width: 100%;
  /* min-width: 100%; */
  max-width: 90%;
  height: 80%;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 2.5rem;
  z-index: 99;

  border-radius: 1rem;
  background: var(--neutral-white);
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.25);
`;

const IconWrap = styled.div`
  width: 100%;
  display: flex;
  justify-content: end;
  margin-bottom: 1rem;
`;

const CloseImg = styled.img`
  width: 3.2rem;
  cursor: pointer;
`;

const ViewerContainer = styled.div`
  width: 100%;
  height: calc(100% - 6.7rem);
  overflow-y: scroll;
`;

export default ResumeModal;
